import React, { useState, useEffect, useCallback } from 'react';
import { checkLength, isEmail } from 'utils';
import { withSnackbar } from 'notistack';
import { withRouter } from 'react-router-dom';
import { Loader, LoginForm } from 'components';
import { firebase } from 'firebase-config';
import { useSelector, useDispatch } from 'react-redux';
import { LoginActions } from 'reducers';
import { makeStyles } from '@material-ui/core/styles';
import { LoginMessages } from 'app-constants';

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(2)
  },
  submit: {
    margin: theme.spacing(2, 0, 3)
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
  toolbar: theme.mixins.toolbar
}));

function Login({ history, enqueueSnackbar }) {
  const location = history && history.location;
  const classes = useStyles();
  const isAdmin = useSelector((state) => state.loginReducer.isAdmin);
  const user = useSelector((state) => state.loginReducer.user);
  const successMessage = useSelector((state) => state.loginReducer.successMessage);
  const errorMessage = useSelector((state) => state.loginReducer.errorMessage);
  const dispatch = useDispatch();
  const [isLoading, setIsloading] = useState(true);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { signIn, resetSuccess, resetError, checkIsAdmin } = LoginActions;

  const displayMessage = useCallback(
    (message, variant) => enqueueSnackbar(message, { variant, preventDuplicate: true }),
    [enqueueSnackbar]
  );

  useEffect(() => {
    const resetMessages = () => {
      dispatch(resetSuccess());
      dispatch(resetError());
    };

    if (isAdmin) {
      displayMessage('Login Success', 'success');
      const { state } = location;
      const pathname = state && state.from && state.from.pathname;
      if (pathname) {
        history.push({
          pathname
        });
      }
    }

    if (errorMessage) {
      displayMessage(LoginMessages[errorMessage] || errorMessage, 'error');
    }
    if (successMessage) {
      displayMessage(LoginMessages[successMessage] || successMessage, 'success');
    }
    resetMessages();
    firebase
      .auth()
      .onAuthStateChanged((user) => (user ? dispatch(checkIsAdmin(user.uid)) : setIsloading(false)));
  }, [
    errorMessage,
    successMessage,
    user,
    isAdmin,
    dispatch,
    displayMessage,
    history,
    checkIsAdmin,
    resetSuccess,
    resetError,
    location
  ]);

  const login = () => {
    dispatch(
      signIn({
        email,
        password
      })
    );
    const userId = user && user.uid;
    dispatch(checkIsAdmin(userId));
  };

  const handleChangeEmail = (event) => setEmail(event.target.value);

  const handleChangePassword = (event) => setPassword(event.target.value);

  const isValid = isEmail(email) && checkLength(password, 6);

  return (
    <>
      {isLoading && <Loader isLoading={isLoading && !isAdmin} />}
      <div className={classes.toolbar} />
      <LoginForm
        isValid={isValid}
        classes={classes}
        setEmail={handleChangeEmail}
        setPassword={handleChangePassword}
        login={login}
      />
    </>
  );
}
export default withRouter(withSnackbar(Login));
